import React from "react";
import { Row, Col, Breadcrumb, Button, Dropdown } from "react-bootstrap";
import { FiDownload, FiChevronUp } from "react-icons/fi";
import { FaRegFileAlt } from "react-icons/fa";
import { RiHome6Line, RiArrowRightSLine } from "react-icons/ri";
import { MdKeyboardArrowRight } from "react-icons/md";
import DomainList from "../../components/super-admin/Domain/DomainList";
const DomainPage = () => {
  return (
    <div
      style={{
        background: "#f5f6f8",
        padding: "20px",
        borderBottom: "1px solid #e6e6e6",
      }}
    >
      <Row className="align-items-center">
        {/* LEFT SIDE */}
        <Col md={6} sm={12}>
          <div className="my-auto mb-2">
            <h4 style={{ fontWeight: "600", marginBottom: "5px" }}>Domain</h4>

            <Breadcrumb
              style={{
                background: "transparent",
                padding: 0,
                margin: 0,
                fontSize: "14px",
              }}
            >
              <Breadcrumb.Item>
                <RiHome6Line
                  className="m text-dark"
                  style={{
                    fontSize: "1.2rem", // increased icon size
                    verticalAlign: "middle",
                  
                  }}
                />
              </Breadcrumb.Item>

              <MdKeyboardArrowRight className="mt-1 fs-5" />

              <Breadcrumb.Item
                linkAs="span"
                className="text-dark text-decoration-none fs-6"
              >
                Super Admin
              </Breadcrumb.Item>

              <MdKeyboardArrowRight className="mt-1 fs-5" />

              <Breadcrumb.Item active>
                <span className="text-dark fs-6">Domain List</span>
              </Breadcrumb.Item>
            </Breadcrumb>
          </div>
        </Col>

        {/* RIGHT SIDE */}
        <Col
          md={6}
          sm={12}
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: "10px",
            flexWrap: "wrap",
          }}
        >
          <Dropdown>
            <Dropdown.Toggle
              style={{
                background: "#fff",
                color: "#374151",
                border: "1px solid #e5e7eb",
                fontSize: "14px",
                padding: "8px 14px",
                display: "flex",
                alignItems: "center",
                gap: "6px",
              }}
            >
              <FiDownload />
              Export
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <Dropdown.Item>PDF</Dropdown.Item>
              <Dropdown.Item>Excel</Dropdown.Item>
              <Dropdown.Item>CSV</Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>

          <Button
            style={{
              background: "#fff",
              border: "1px solid #e5e7eb",
              color: "#374151",
              padding: "8px 10px",
            }}
          >
            <FiChevronUp />
          </Button>
        </Col>
      </Row>
      <DomainList />
    </div>
  );
};

export default DomainPage;
